import React from 'react'
import { useDevice } from 'device'

import { WidthContainer } from 'components/layout'
import { Text, Video } from 'components/dataDisplay'

import brandsMobileImage from './images/mobile-brands.png'
import brandsDesktopVideo from './images/desktop-brands.mp4'

import messages from './messages'

import s from './BrandsRow.scss'


const BrandsRowAb: React.FunctionComponent = () => {
  const { isMobile } = useDevice()

  if (isMobile) {
    return (
      <div className="mt-24 overflow-hidden">
        <div className="flex h-[80rem]">
          <img className={s.image} src={brandsMobileImage} />
          <img className={s.image} src={brandsMobileImage} />
        </div>
        <Text className="mt-24 text-center" message={messages.text} style="p3" />
      </div>
    )
  }

  return (
    <WidthContainer className="text-center">
      <Video
        videoClassName="bg-light"
        url={brandsDesktopVideo}
        type="mp4"
        fit="contain"
        autoplay
        muted
        loop
        aspect={1190 / 126}
        withBackground={false}
      />
      <Text message={messages.text} style="p1" />
    </WidthContainer>
  )
}


export default BrandsRowAb
